import api from "../../../../lib/api";
import { IEditVehicleTypePayload, IVehicleTypeCreate, IVehicleTypeListSearch } from "../../../../types/master/vehicleTypeInterface";

export const createVehicleTypeApi = async (data: IVehicleTypeCreate) => {
  return await api.post(`/vehicletype`, data);
};

export const getVehicleTypeListApi = async (data: IVehicleTypeListSearch) => {
  return await api.get(`/vehicletype/${data.page}/${data.pageLimit}?search=${data?.search??""}`)
}

export const getVehicleTypeDataByIdApi = async (id: number) => {
  return await api.get(`/vehicletype/${id}`)
}

export const editVehicleTypeDataByIdApi = async (payload: IEditVehicleTypePayload) => {
  return await api.put(`/vehicletype/${payload.id}`, payload.data);
};